import React from 'react';
import { Link as GatsbyLink, graphql } from 'gatsby';
import styled from 'styled-components';

import { truncate } from '@sayido/utils';

const Image = styled.div`
  background: url(${({ image }) => image}) center/cover #e8e8e8;
  display: block;
  border-radius: 6px;
  width: 100%;
  height: var(--img-height);
`;

const Title = styled.h3`
  color: #444;
  font-family: secondarytypeface, serif;
  font-size: 1em;
  font-weight: 100;
  margin: 0;
  position: relative;
  text-decoration: none;

  :hover > & {
    text-decoration: underline;
  }
`;

const StandFirst = styled.p`
  font-family: bodytypeface, sans-serif;
  font-weight: 100;
  color: #444;
  font-size: 14px;
`;

const Link = styled(GatsbyLink)`
  text-decoration: none;
  color: #444;
  font-size: ${({ size }) => (size === 'lg' ? '26px' : '18px')};
  grid-gap: 12px;
  display: grid;

  &:hover {
    transform: translateY(-2px);
    transition: transform 0.2s;
    text-decoration: none;
    ${Title} {
      text-decoration: underline;
    }
  }
`;

const HorizontalLink = styled(Link)`
  --img-height: ${({ size }) => (size === 'lg' ? '200px' : '120px')};
  grid-template-columns: minmax(100px, 200px) auto;
  grid-template-rows: 1fr;
`;
const VerticalLink = styled(Link)`
  --img-height: ${({ size }) => (size === 'lg' ? '300px' : '120px')};
  grid-template-columns: 1fr;
  grid-template-rows: minmax(min-content, max-content) auto;
`;

const ArticleCard = ({
  article,
  layout = 'horizontal',
  size = 'md',
  elements = {},
}) => {
  const { stand_first: showStandfirst = true } = elements;
  const LinkWrapper = layout === 'horizontal' ? HorizontalLink : VerticalLink;

  const imageSize = layout === 'horizontal' ? 'small' : 'medium';
  const imageUrl = article?.image?.formats?.[imageSize]?.url;

  const image = imageUrl;

  return (
    <LinkWrapper to={`/articles/${article.slug}`} size={size}>
      <Image image={image} />
      <div>
        <Title>{article.title}</Title>
        {showStandfirst && (
          <StandFirst>
            {truncate(article.stand_first, size === 'lg' ? 280 : 140)}
          </StandFirst>
        )}
      </div>
    </LinkWrapper>
  );
};

export const query = graphql`
  fragment ArticleCard on STRAPI_ARTICLE {
    id
    slug
    title
    title_tag
    meta_description
    description
    image {
      url
    }
  }
`;

export default ArticleCard;
